/**
 * LoginRedirectModal — Modal para redirigir al subdominio del tenant.
 * Se abre al hacer click en "Entrar" en la LandingPage.
 */
import { useState, useEffect, useRef } from "react";

export default function LoginRedirectModal({ open, onClose }) {
    const [sub, setSub] = useState("");
    const [error, setError] = useState("");
    const inputRef = useRef(null);

    useEffect(() => {
        if (open && inputRef.current) inputRef.current.focus();
        if (!open) { setSub(""); setError(""); }
    }, [open]);

    if (!open) return null;

    const getBaseHost = () => {
        const host = window.location.hostname;
        if (host === "sass.local" || host === "localhost" || host === "127.0.0.1") return "sass.local";
        // Si es conexopos.com o sub.conexopos.com, la base es conexopos.com
        if (host.includes("conexopos.com")) return "conexopos.com";
        return host;
    };

    const baseHost = getBaseHost();

    const handleSubmit = (e) => {
        e.preventDefault();
        const slug = sub.trim().toLowerCase().replace(/[^a-z0-9-]/g, "");
        if (!slug) { setError("Introduce tu subdominio."); return; }
        if (slug.length < 2) { setError("El subdominio debe tener al menos 2 caracteres."); return; }

        const port = window.location.port ? `:${window.location.port}` : "";
        const protocol = window.location.protocol;
        const tenantUrl = `${protocol}//${slug}.${baseHost}${port}/staff`;
        window.location.href = tenantUrl;
    };

    return (
        <div style={s.overlay} onClick={onClose}>
            <div style={s.modal} onClick={(e) => e.stopPropagation()}>
                <button id="modal-close" style={s.closeBtn} onClick={onClose}>✕</button>

                <div style={s.icon}>🔑</div>
                <h2 style={s.title}>Acceder al sistema</h2>
                <p style={s.sub}>Introduce el subdominio de Conexo POS para continuar.</p>

                <form onSubmit={handleSubmit} style={s.form}>
                    <div style={s.inputGroup}>
                        <div style={s.inputWrapper}>
                            <input
                                id="subdomain-input"
                                ref={inputRef}
                                value={sub}
                                onChange={(e) => { setSub(e.target.value); setError(""); }}
                                placeholder="mi-restaurante"
                                style={s.input}
                                autoComplete="off"
                                spellCheck={false}
                            />
                            <span style={s.suffix}>.{baseHost}</span>
                        </div>
                        {error && <p style={s.error}>{error}</p>}
                    </div>

                    <button id="modal-submit" type="submit" style={s.btn}>
                        Entrar →
                    </button>
                </form>

                <p style={s.hint}>
                    ¿Aún no tienes cuenta?{" "}
                    <a href="/onboarding" style={s.link}>Crea Conexo POS gratis</a>
                </p>
            </div>
        </div>
    );
}

const s = {
    overlay: {
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(8px)",
        display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: "1rem",
    },
    modal: {
        background: "#1e1e2e", border: "1px solid rgba(255,255,255,0.1)",
        borderRadius: "1.5rem", padding: "2.5rem", maxWidth: "440px", width: "100%",
        position: "relative", textAlign: "center", fontFamily: "'Inter', system-ui, sans-serif",
    },
    closeBtn: {
        position: "absolute", top: "1rem", right: "1rem",
        background: "none", border: "none", color: "#64748b",
        cursor: "pointer", fontSize: "1rem", padding: "0.25rem",
    },
    icon: { fontSize: "2.5rem", marginBottom: "1rem" },
    title: { color: "#fff", fontSize: "1.4rem", fontWeight: "700", margin: "0 0 0.5rem" },
    sub: { color: "#94a3b8", fontSize: "0.9rem", margin: "0 0 1.75rem" },
    form: { display: "flex", flexDirection: "column", gap: "0.875rem" },
    inputGroup: { display: "flex", flexDirection: "column", gap: "0.375rem" },
    inputWrapper: {
        display: "flex", alignItems: "center",
        background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)",
        borderRadius: "0.75rem", overflow: "hidden",
    },
    input: {
        flex: 1, background: "none", border: "none", outline: "none",
        padding: "0.75rem 0.875rem", color: "#fff", fontFamily: "monospace",
        fontSize: "0.95rem",
    },
    suffix: { color: "#64748b", paddingRight: "0.875rem", fontSize: "0.85rem", fontFamily: "monospace" },
    error: { color: "#f87171", fontSize: "0.8rem", textAlign: "left", margin: 0 },
    btn: {
        background: "linear-gradient(135deg, #EAB308, #f59e0b)",
        border: "none", borderRadius: "0.75rem", padding: "0.875rem 1.5rem",
        color: "#000", fontWeight: "700", fontSize: "1rem", cursor: "pointer",
        transition: "opacity 0.15s",
    },
    hint: { color: "#64748b", fontSize: "0.8rem", marginTop: "1.25rem" },
    link: { color: "#EAB308", textDecoration: "none" },
};
